// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"7c24096a","841":"3cf72a6d"}[chunkId] + ".chunk.css";
};